import { api } from '../lib/api';

/** GET /v1/device/codes/:userCode */
export interface DeviceCodeDetails {
  label: string;
  alreadyHandled: boolean;
  /**
   * Whether the code was asked for from the network this browser is on.
   * Null when the API does not know. False is the sign of a code somebody
   * else started and sent here in a link.
   */
  sameNetwork?: boolean | null;
  createdAt?: string;
}

export function fetchDeviceCode(userCode: string): Promise<DeviceCodeDetails> {
  return api<DeviceCodeDetails>(`/v1/device/codes/${encodeURIComponent(userCode)}`);
}

export function decideDeviceCode(
  userCode: string,
  decision: 'approve' | 'deny',
): Promise<{ ok: boolean; decision: string }> {
  return api(`/v1/device/codes/${encodeURIComponent(userCode)}/decision`, {
    method: 'POST',
    body: { decision },
  });
}

/** POST /v1/device/handoff, for a browser that is already signed in. */
export function startDesktopHandoff(label: string): Promise<{ deviceCode: string; expiresInSec: number }> {
  return api('/v1/device/handoff', { method: 'POST', body: { label } });
}

/** GET /v1/device/sessions: everything signed in as this person, apps and desktops. */
export interface DeviceSession {
  id: string;
  label: string;
  createdAt: string;
  lastUsedAt: string | null;
  expiresAt: string;
  /** An app that signed in through OAuth (Claude, Cursor), or a desktop through the device flow. */
  kind: 'app' | 'desktop';
}

export function fetchDeviceSessions(): Promise<{ sessions: DeviceSession[] }> {
  return api('/v1/device/sessions');
}

export function revokeDeviceSession(id: string): Promise<void> {
  return api(`/v1/device/sessions/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
